(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hevisynx-all-products-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var filter = document.querySelector('.hx-all-filter');
    var productList = document.querySelector('.hxc-page .hxc-products-wrap');
    var hero = document.querySelector('.hxc-page .hxc-hero');
    var matchForm = document.querySelector('.hxc-page .hxc-match');
    var activeRequest = null;
    var i18nElement = document.querySelector('[data-hx-filter-i18n]');
    var i18n = i18nElement ? JSON.parse(i18nElement.textContent) : {};

    if (!filter || !productList) {
      return;
    }

    if (hero) {
      hero.insertAdjacentElement('afterend', productList);
    }

    if (matchForm) {
      matchForm.hidden = true;
      matchForm.style.display = 'none';
    }

    function createEmptyState() {
      var emptyState = document.createElement('div');
      emptyState.className = 'hx-empty-products';
      emptyState.setAttribute('role', 'status');
      emptyState.innerHTML =
        '<span>' + i18n.noMatches + '</span>' +
        '<h3>' + i18n.noProducts + '</h3>' +
        '<p>' + i18n.help + '</p>' +
        '<a href="' + (filter.getAttribute('data-collection-url') || '/collections/all') + '">' + i18n.clear + '</a>';
      return emptyState;
    }

    function preservePreviewLinks(root) {
      var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');

      if (!previewThemeId) {
        return;
      }

      root.querySelectorAll('a[href]').forEach(function(link) {
        var destination = new URL(link.href, window.location.origin);
        destination.searchParams.set('preview_theme_id', previewThemeId);
        link.href = destination.pathname + destination.search;
      });
    }

    function setMobilePanelState(targetFilter) {
      var panel = targetFilter.querySelector('.hx-filter-panel');
      var hasActiveTag = Boolean(targetFilter.querySelector('.hx-tag-link.is-active'));

      if (panel && window.matchMedia('(max-width: 900px)').matches && !hasActiveTag) {
        panel.removeAttribute('open');
      }
    }

    function getSelectedHandles(targetFilter, currentUrl) {
      var url = new URL(currentUrl, window.location.origin);
      var collectionPath = targetFilter.getAttribute('data-collection-url') || '/collections/all';
      var tagPrefix = collectionPath.replace(/\/$/, '') + '/';

      if (url.pathname.indexOf(tagPrefix) !== 0) {
        return [];
      }

      var tagPath = decodeURIComponent(url.pathname.slice(tagPrefix.length));
      return tagPath ? tagPath.split('+').filter(Boolean) : [];
    }

    function buildFilterUrl(targetFilter, currentUrl, handles) {
      var current = new URL(currentUrl, window.location.origin);
      var collectionPath = targetFilter.getAttribute('data-collection-url') || '/collections/all';
      var path = collectionPath.replace(/\/$/, '');

      if (handles.length) {
        path += '/' + handles.join('+');
      }

      var destination = new URL(path, window.location.origin);
      current.searchParams.forEach(function(value, key) {
        if (key !== 'page' && key !== 'sections' && key !== 'section_id') {
          destination.searchParams.append(key, value);
        }
      });
      return destination.pathname + destination.search;
    }

    function syncFilterState(targetFilter, currentUrl) {
      var selectedHandles = getSelectedHandles(targetFilter, currentUrl);
      var count = selectedHandles.length;
      var panelSummary = targetFilter.querySelector('.hx-filter-panel > summary');
      var countBadge = panelSummary ? panelSummary.querySelector('small') : null;

      targetFilter.querySelectorAll('.hx-tag-link[data-tag-handle]').forEach(function(item) {
        var handle = item.getAttribute('data-tag-handle');
        var isActive = selectedHandles.indexOf(handle) !== -1;
        var link = item.querySelector('a');
        var nextHandles = selectedHandles.slice();

        item.classList.toggle('is-active', isActive);

        if (!link) {
          return;
        }

        link.setAttribute('role', 'checkbox');
        link.setAttribute('aria-checked', isActive ? 'true' : 'false');

        if (isActive) {
          nextHandles = nextHandles.filter(function(selectedHandle) {
            return selectedHandle !== handle;
          });
        } else {
          nextHandles.push(handle);
        }

        link.href = buildFilterUrl(targetFilter, currentUrl, nextHandles);
      });

      if (panelSummary) {
        if (count && !countBadge) {
          countBadge = document.createElement('small');
          panelSummary.appendChild(countBadge);
        }

        if (countBadge) {
          countBadge.textContent = (i18n.active || '{{ count }} active').replace('{{ count }}', count);
          countBadge.hidden = count === 0;
        }
      }

      var clearLink = targetFilter.querySelector('[data-clear-filters]');
      if (clearLink) {
        clearLink.hidden = count === 0;
        clearLink.href = buildFilterUrl(targetFilter, currentUrl, []);
      }
    }

    function mountProducts(targetFilter, targetProductList, openGroups, currentUrl) {
      var targetGrid = targetProductList.querySelector('.hxc-product-list');

      if (!targetGrid) {
        targetGrid = createEmptyState();
        targetProductList.appendChild(targetGrid);
      }

      var targetLayout = document.createElement('div');
      targetLayout.className = 'hx-products-layout';
      targetLayout.setAttribute('data-loading-label', i18n.updating || '');
      targetGrid.parentNode.insertBefore(targetLayout, targetGrid);
      targetLayout.appendChild(targetFilter);
      targetLayout.appendChild(targetGrid);

      if (openGroups && openGroups.length) {
        targetFilter.querySelectorAll('.hx-tag-group').forEach(function(group) {
          var summary = group.querySelector('summary');
          if (summary && openGroups.indexOf(summary.textContent.trim()) !== -1) {
            group.open = true;
          }
        });
      }

      syncFilterState(targetFilter, currentUrl);
      preservePreviewLinks(targetLayout);
      setMobilePanelState(targetFilter);

      filter = targetFilter;
      productList = targetProductList;
      return targetLayout;
    }

    mountProducts(filter, productList, null, window.location.href);

    function getOpenGroups() {
      return Array.from(filter.querySelectorAll('.hx-tag-group[open] summary')).map(function(summary) {
        return summary.textContent.trim();
      });
    }

    function updateProducts(destination, updateHistory) {
      var currentLayout = productList.querySelector('.hx-products-layout');
      var openGroups = getOpenGroups();

      if (activeRequest) {
        activeRequest.abort();
      }

      var request = new AbortController();
      activeRequest = request;

      if (currentLayout) {
        currentLayout.classList.add('is-loading');
        currentLayout.setAttribute('aria-busy', 'true');
      }

      return fetch(destination, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        signal: request.signal
      })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Unable to update products');
          }
          return response.text();
        })
        .then(function(html) {
          var nextDocument = new DOMParser().parseFromString(html, 'text/html');
          var nextFilter = nextDocument.querySelector('.hx-all-filter');
          var nextProductList = nextDocument.querySelector('.hxc-page .hxc-products-wrap');

          if (!nextFilter || !nextProductList) {
            throw new Error('Product results were not found');
          }

          productList.replaceWith(nextProductList);
          mountProducts(nextFilter, nextProductList, openGroups, destination);

          if (updateHistory) {
            window.history.pushState({}, '', destination);
          }

          if (nextDocument.title) {
            document.title = nextDocument.title;
          }
        })
        .catch(function(error) {
          if (error.name === 'AbortError') {
            return;
          }
          window.location.assign(destination);
        })
        .finally(function() {
          if (activeRequest === request) {
            activeRequest = null;
          }
        });
    }

    document.addEventListener('click', function(event) {
      var link = event.target.closest('.hx-all-filter a[href], .hx-empty-products a[href]');

      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      var destination = new URL(link.href, window.location.origin);

      if (destination.origin !== window.location.origin) {
        return;
      }

      event.preventDefault();
      var clickedItem = link.closest('.hx-tag-link');
      if (clickedItem) {
        clickedItem.classList.toggle('is-active');
      }
      updateProducts(destination.pathname + destination.search, true);
    });

    window.addEventListener('popstate', function() {
      updateProducts(window.location.pathname + window.location.search, false);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hevisynx-all-products-hero-layout"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var marker = document.querySelector('.hx-catalog-hero-layout');
    var page = document.querySelector('.hxc-page');

    if (marker && page) {
      page.classList.add('hxc-page--all-products');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hevisynx-homepage"] && !Shopify.designMode) return;
  try {
    
const hxMotionCleanup = new WeakMap();
function hxInitHeroMotion(scope) {
  scope.querySelectorAll('[data-hx-motion]').forEach((hero) => {
    if (hxMotionCleanup.has(hero)) return;
    const button = hero.querySelector('.hx-motion-toggle');
    if (!button || !('IntersectionObserver' in window)) return;
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let paused = false;
    const sync = () => {
      hero.dataset.motionActive = String(visible && !paused && !preference.matches && !document.hidden);
      button.hidden = preference.matches;
      button.textContent = paused ? button.dataset.labelPlay : button.dataset.labelPause;
    };
    const toggle = () => {
      paused = !paused;
      sync();
    };
    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      sync();
    }, { threshold: .05 });
    hero.dataset.motionReady = 'true';
    button.addEventListener('click', toggle);
    preference.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    observer.observe(hero);
    sync();
    hxMotionCleanup.set(hero, () => {
      observer.disconnect();
      button.removeEventListener('click', toggle);
      preference.removeEventListener('change', sync);
      document.removeEventListener('visibilitychange', sync);
      delete hero.dataset.motionReady;
      delete hero.dataset.motionActive;
      hxMotionCleanup.delete(hero);
    });
  });
}
hxInitHeroMotion(document);
document.addEventListener('shopify:section:load', (event) => hxInitHeroMotion(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-hx-motion]').forEach((hero) => hxMotionCleanup.get(hero)?.());
});

  } catch(e) { console.error(e); }
})();
})();
